import * as React from 'react';
import { InternalApiEntityType } from '../api-internal';
import { EntitySchema } from './EntitySchema';
import { SalvTab, SalvTabList, SalvTabPanel, SalvTabs } from '@salvapp/ui-components';
import Has from '../auth/Has';
import { CAN_MODIFY_SCHEMA, CAN_READ_SCHEMA } from '../auth/permissions';
import SalvPage from '../common/SalvPage';
import { getConfigurationUrl } from '../navigation/helper';
import { ConfigurationProduct } from '../settings/configuration/Configuration';

const EntitySchemas = () => {
  return (
    <SalvPage
      title={'Entity Schemas'}
      breadcrumb={{
        title: 'Configuration',
        to: getConfigurationUrl(ConfigurationProduct.GENERAL),
      }}
    >
      <Has anyPermissions={[CAN_READ_SCHEMA, CAN_MODIFY_SCHEMA]}>
        <SalvTabs className={'p-b-64'}>
          <SalvTabList>
            <SalvTab value={'person'} title={'Person'} />
            <SalvTab value={'transaction'} title={'Transaction'} />
          </SalvTabList>
          <SalvTabPanel value={'person'}>
            <EntitySchema entityType={InternalApiEntityType.PERSON} />
          </SalvTabPanel>
          <SalvTabPanel value={'transaction'}>
            <EntitySchema entityType={InternalApiEntityType.TRANSACTION} />
          </SalvTabPanel>
        </SalvTabs>
      </Has>
    </SalvPage>
  );
};

export default EntitySchemas;
